import dayjs from 'dayjs';
import 'dayjs/locale/en';
import { Calender } from './styles';
import { rootStore } from '../../mobx/rootStore';
interface ActionProps {
  date: Date;
  textBlack?: boolean;
}
const Actions = (props: ActionProps) => {
  const { date, textBlack = false } = props;
  //use selector state variables
  const { currentUser } = rootStore;
  return (
    <Calender textBlack={textBlack}>
      <p className='text-center'>{date ? dayjs(date).format(`ddd, ${currentUser?.dateFormat}`) : 'No Due Date'}</p>
    </Calender>
  );
};

export default Actions;
